import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import style from './styles/style.module.css';

export default class PillButton extends PureComponent {
    render() {
        const className = ( style.pillButton + ' ' + this.props.className ).trim();
        return (
            <button onClick={ this.props.onClick } className={ className }
            data-reverse={ this.props.reverse }>
                { this.props.label }
            </button>
        );
    }
}
PillButton.propTypes = {
    label: PropTypes.oneOfType( [
        PropTypes.string,
        PropTypes.object,
    ] ),
    className: PropTypes.string,
    onClick: PropTypes.func,
};
PillButton.defaultProps = {
    label: '',
    className: '',
    onClick: () => {},
};
